<template>
  <div class="prod-section-head">
    <div class="min-w-0">
      <h3 class="prod-section-head__title">{{ title }}</h3>
      <p v-if="subtitle" class="prod-section-head__sub">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.default" class="shrink-0">
      <slot />
    </div>
  </div>
</template>

<script setup>
/* global defineProps */
defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  }
})
</script>
